import {
  getAllCompany,
  addCompany,
  updateCompany,
  deleteCompanyById,
  getCompanyById,
  getBookingByCompanyId,
  getCustomerByCompanyId,
  addCustomerInCompanyId,
} from "../../../helpers/backend_helper";
import {
  companyError,
  companyRequest,
  companySuccess,
  CustomerByCompanyIdError,
  CustomerByCompanyIdRequest,
  CustomerByCompanyIdSuccess,
  getBookingByCompanyIdError,
  getBookingByCompanyIdRequest,
  getBookingByCompanyIdSuccess,
  getCompanyByIdError,
  getCompanyByIdRequest,
  getCompanyByIdSuccess,
  getCustomerByCompanyIdError,
  getCustomerByCompanyIdRequest,
  getCustomerByCompanyIdSuccess,
} from "./reducer";

export const fetchCompany =
  (page: number, count: number, keyword: string, status: string) =>
  async (dispatch: any) => {
    dispatch(companyRequest());
    try {
      const response: any = await getAllCompany(page, count, keyword, status);
      if (response && response.isSuccess) {
        dispatch(companySuccess(response.data));
        return response;
      } else {
        dispatch(companyError("Failed to fetch Company"));
        return null;
      }
    } catch (error: any) {
      dispatch(companyError(error.message));
      return null;
    }
  };

export const addNewCompany = (userData: any) => async (dispatch: any) => {
  dispatch(companyRequest());
  try {
    const response: any = await addCompany(userData);

    if (response && response.data) {
      dispatch(companySuccess(response.data));
      return response; // ✅ yahan poora backend response return hoga
    } else {
      dispatch(companyError("Failed to add company"));
      return response;
    }
  } catch (error: any) {
    dispatch(companyError(error.message));
    return { message: error.message, isSuccess: false, data: null }; // Optional: same format maintain karne ke liye
  }
};

export const editCompany = (updatedData: any) => async (dispatch: any) => {
  dispatch(companyRequest());
  try {
    const response: any = await updateCompany(updatedData);
    if (response && response.data) {
      dispatch(companySuccess(response.data));
      return response;
    } else {
      dispatch(companyError("Failed to edit user"));
      return response;
    }
  } catch (error: any) {
    dispatch(companyError(error.message));
    return null;
  }
};

export const removeCompany = (id: string) => async (dispatch: any) => {
  dispatch(companyRequest());
  try {
    const response: any = await deleteCompanyById(id);

    if (response && response.isSuccess) {
      dispatch(companySuccess(response.data));
      return response;
    } else {
      dispatch(companyError("Failed to fetch company by ID"));
      return response;
    }
  } catch (error: any) {
    dispatch(companyError(error.message));
    return null;
  }
};

export const fetchCompanyById = (userId: string) => async (dispatch: any) => {
  dispatch(getCompanyByIdRequest());
  try {
    const response: any = await getCompanyById(userId);

    if (response && response.isSuccess) {
      dispatch(getCompanyByIdSuccess(response.data));
      return response;
    } else {
      dispatch(getCompanyByIdError("Failed to fetch Company by ID"));
      return response;
    }
  } catch (error: any) {
    dispatch(getCompanyByIdError(error.message));
    return null;
  }
};

export const fetchBookingByCompanyId =
  (
    companyId: any,
    tripStatus: string,
    page: number,
    count: number,
    allRideSearch: string
  ) =>
  async (dispatch: any) => {
    dispatch(getBookingByCompanyIdRequest());
    try {
      // API call — function ko import karna hoga jese getCompanyById tha
      const response: any = await getBookingByCompanyId(
        companyId,
        tripStatus,
        page,
        count,
        allRideSearch
      );

      if (response && response.isSuccess) {
        dispatch(getBookingByCompanyIdSuccess(response.data));
        return response;
      } else {
        dispatch(
          getBookingByCompanyIdError("Failed to fetch bookings by Company ID")
        );
        return response;
      }
    } catch (error: any) {
      dispatch(getBookingByCompanyIdError(error.message));
      return null;
    }
  };

export const fetchCustomerByCompanyId =
  (companyId: any, page: number, count: number, keyword: string) =>
  async (dispatch: any) => {
    // 1. Dispatch Request Action
    dispatch(getCustomerByCompanyIdRequest());

    try {
      const response: any = await getCustomerByCompanyId(
        companyId,
        page,
        keyword,
        count
      );

      if (response && response.isSuccess) {
        dispatch(getCustomerByCompanyIdSuccess(response.data));
        return response;
      } else {
        dispatch(
          getCustomerByCompanyIdError(
            response?.message || "Failed to fetch customers by Company ID"
          )
        );
        return response;
      }
    } catch (error: any) {
      console.error("Error in getCustomerByCompanyId thunk:", error);
      dispatch(getCustomerByCompanyIdError(error.message));
      return null;
    }
  };

export const addCustomerInCompany =
  (companyId: string | undefined, customerIds: string[]) =>
  async (dispatch: any) => {
    dispatch(CustomerByCompanyIdRequest());

    try {
      let data: any = {
        companyId: companyId,
        customerIds: customerIds,
      };
      const response: any = await addCustomerInCompanyId(data);

      if (response && response.isSuccess) {
        dispatch(CustomerByCompanyIdSuccess(response.data));
        return response;
      } else {
        dispatch(
          CustomerByCompanyIdError(
            response?.message || "Failed to fetch customers by Company ID"
          )
        );
        return response;
      }
    } catch (error: any) {
      console.error("Error in getCustomerByCompanyId thunk:", error);
      dispatch(CustomerByCompanyIdError(error.message));
      return null;
    }
  };


